// @flow
import React from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {
    AlertScreenButton,
    AlertScreenButtonsRow,
    AlertScreenContent,
    AlertScreenContentDiv,
    AlertScreenOverlayMessageWindow,
    AlertScreenTitle,
    AlertScreenButtonSingle, AlertScreenButtonLeft, AlertScreenButtonRight,
} from "./AlertStyle";
import AppTypes from "../../../Store/Ducks/App/types";
import AppSelectors from "../../../Store/Ducks/App/selectors";
import type {AlertData, CSSDirectionType} from "../../../Store/Ducks/App/utils";
import type {Dispatch} from "redux";
import {CSSDirection} from "../../../Store/Ducks/App/utils";

type ConnectedProps = {
    alert: AlertData,
    direction: CSSDirectionType,
    dispatch: Dispatch,
}

const Alert = (props: ConnectedProps) => {
    const alert = props.alert;
    const buttons = alert.buttons || [];
    const numberOfButtons = buttons.length;
    const StartComponent = props.direction === CSSDirection.ltr ? AlertScreenButtonLeft : AlertScreenButtonRight;
    const EndComponent = props.direction === CSSDirection.ltr ? AlertScreenButtonRight : AlertScreenButtonLeft;
    return (
        <AlertScreenOverlayMessageWindow>
            <AlertScreenContentDiv>
                <AlertScreenTitle>
                    {alert.title}
                </AlertScreenTitle>
            </AlertScreenContentDiv>
            <AlertScreenContentDiv>
                <AlertScreenContent>
                    {alert.content}
                </AlertScreenContent>
            </AlertScreenContentDiv>
            <AlertScreenButtonsRow>
                {buttons.map((button, index) => {
                    let actions = button.actions || [];
                    actions.push(AppTypes.ALERT_DATA_CLEAR);
                    const buttonProps = {
                        style: {
                            width: `${100 / numberOfButtons}%`,
                        },
                        children: button.text,
                        key: button.text,
                        onClick: () => {
                            actions.forEach((action) => props.dispatch({type: action}));
                        },
                    };
                    if (numberOfButtons === 1) {
                        return <AlertScreenButtonSingle {...buttonProps}/>;
                    }
                    if (index === 0) {
                        return <StartComponent {...buttonProps}/>;
                    }
                    if (index === numberOfButtons - 1) {
                        return <EndComponent {...buttonProps}/>;
                    }
                    return <AlertScreenButton {...buttonProps}/>;

                })}
            </AlertScreenButtonsRow>
        </AlertScreenOverlayMessageWindow>
    );
};

const mapStateToProps = (state, props) => {
    return {
        alert: AppSelectors.getAlert(state),
        direction: AppSelectors.getCSSDirection(state),
    };
};

const mapActionsToProps = (dispatch, props) => {
    return {...bindActionCreators({}, dispatch), dispatch};
};

export default connect(mapStateToProps, mapActionsToProps)(Alert);



// WEBPACK FOOTER //
// ./src/Components/GreyOverlay/Alert/Alert.js